import React, { useContext, useEffect, useRef, useState } from "react";
import noteContext from "../context/notes/noteContext";
import Noteitem from "./Noteitem";
import AddNote from "./AddNote";

const Notes = (props) => {
  const { showAlert } = props;

  const context = useContext(noteContext);
  const { notes, getNotes, editNote } = context;

  // 🔐 Load notes only if logged in
  useEffect(() => {
    if (localStorage.getItem("token")) {
      getNotes();
    }
    // eslint-disable-next-line
  }, []);

  // Modal refs
  const ref = useRef(null);
  const refClose = useRef(null);

  // State for editing note
  const [note, setNote] = useState({
    id: "",
    etitle: "",
    edescription: "",
    etag: "",
  });

  // Open modal + fill data
  const updateNote = (currentNote) => {
    ref.current.click();
    setNote({
      id: currentNote._id,
      etitle: currentNote.title,
      edescription: currentNote.description,
      etag: currentNote.tag,
    });
  };

  // Save edited note
  const handleClick = () => {
    editNote(note.id, note.etitle, note.edescription, note.etag);
    showAlert("Note updated successfully", "success");
    refClose.current.click();
  };

  const onChange = (e) => {
    setNote({ ...note, [e.target.name]: e.target.value });
  };

  return (
    <>
      {/* ➕ Add Note */}
      <AddNote showAlert={showAlert} />

      {/* Hidden button for modal */}
      <button
        ref={ref}
        type="button"
        className="btn btn-primary d-none"
        data-bs-toggle="modal"
        data-bs-target="#editModal"
      >
        Launch modal
      </button>

      {/* 📝 Edit Modal */}
      <div className="modal fade" id="editModal" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Edit Note</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <form className="my-3">

                <div className="mb-3">
                  <label className="form-label">Title</label>
                  <input
                    type="text"
                    className="form-control"
                    name="etitle"
                    value={note.etitle}
                    onChange={onChange}
                    minLength={5}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Description</label>
                  <input
                    type="text"
                    className="form-control"
                    name="edescription"
                    value={note.edescription}
                    onChange={onChange}
                    minLength={5}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Tag</label>
                  <input
                    type="text"
                    className="form-control"
                    name="etag"
                    value={note.etag}
                    onChange={onChange}
                  />
                </div>

              </form>
            </div>

            <div className="modal-footer">
              <button
                ref={refClose}
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>

              <button
                disabled={
                  note.etitle.length < 5 ||
                  note.edescription.length < 5
                }
                onClick={handleClick}
                type="button"
                className="btn btn-primary"
              >
                Update Note
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* 📒 Notes List */}
      <div className="row my-3">
        <h2>Your Notes</h2>

        <div className="container mx-2">
          {notes && notes.length === 0 && "No notes to display"}
        </div>

        {/* ✅ SAFE MAP */}
        {notes &&
          notes.map((note) => (
            <Noteitem
              key={note._id}
              note={note}
              updateNote={updateNote}
              showAlert={showAlert}
            />
          ))}
      </div>
    </>
  );
};

export default Notes;
